<script>
  import Container from '~/components/ui/container.svelte'
</script>

<section>
  <Container>
    <div class="headline-animation min-h-[10vh] lg:h-auto lg:border-l-2 lg:border-gray-300 lg:px-8">
      <h1 class="el-animated mb-6 text-4xl lg:w-2/3 lg:text-7xl">Política de Privacidade</h1>
      <p class="el-animated text-md lg:w-8/12">
        <strong class="font-normal">Última atualização: 18/05/2025 ás 6:00</strong>
      </p>
    </div>

    <hr class="my-[48px]" />
  </Container>
</section>
